import React from 'react';
import { MdOutlineFileUpload } from "react-icons/md";
import { FilledButton, FlatButton, OutlinedButton } from './Button';
import useCurrentUser from '../../hooks/useCurrentUser';

type AvatarProps = {
  imageUrl: string; // URL of the avatar image
  theme?: 'primary' | 'secondary' | 'accent'; // Optional theme for border
  onUpload?: () => void; // Function to trigger when the upload button is clicked
};

const themeBorderClasses = {
  primary: 'border-primary',
  secondary: 'border-secondary',
  accent: 'border-accent'
};

const Avatar: React.FC<AvatarProps> = ({ imageUrl, theme, onUpload }) => {
  const borderClass = theme ? themeBorderClasses[theme] : '';

  const { profilePictureLoading } = useCurrentUser();


  return (
    <div className="flex flex-col items-center space-y-2 w-fit">
      {/* Avatar Image */}
      <div className={`rounded-full overflow-hidden ${borderClass} border-2`}>
        <img src={imageUrl} alt="User Avatar" className="w-52 h-52 object-cover" />
      </div>

      {/* Upload Button */}
      {onUpload && (
        <p className="caption2 text-secondary-300 font-bold cursor-pointer underline" onClick={onUpload}>
          Change Image
        </p>
      )}
    </div>
  );
};

export default Avatar;